{
  "title": "如何確認開賽前的準備狀態",
  "description": "使用競賽總覽頁的「準備狀態」清單，確認開賽前還有哪些設定尚未完成。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您可以清楚看到這場競賽還有哪些設定項目尚未就緒，逐一補齊後就能安心開放給參賽者。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["已具備該競賽的管理權限"],
  "pathLabel": "主辦方主控台 → 競賽總覽 → 準備狀態",
  "steps": [
    {
      "title": "1. 開啟競賽總覽頁",
      "description": "進入該場競賽的總覽頁，「準備狀態」卡片會即時依據目前實際設定計算出來，不是預先寫死的靜態清單。"
    },
    {
      "title": "2. 查看「需要處理」清單",
      "description": "預設只顯示尚未就緒的項目，共 9 項可能出現：基本資訊、排程、資格條件、類別、動態表單、評分規準、評審設定、公開頁面、發布。"
    },
    {
      "title": "3. 點選項目直接前往設定",
      "description": "「類別」「動態表單」「評分規準」「評審設定」等項目可直接點選連結跳轉到對應設定分頁；逐一完成後，該項目會從「需要處理」清單消失。"
    },
    {
      "title": "4. 展開完整清單確認整體進度",
      "description": "可展開摘要（顯示「N／9 已完成」）查看包含已就緒項目在內的完整清單，確認整體完成度。"
    }
  ],
  "afterward": [
    "當所有項目皆顯示「已就緒」時，「需要處理」清單會顯示「目前沒有需要立即處理的設定」",
    "此清單是即時計算結果，任何設定變更（例如新增類別、發布表單）都會立刻反映在清單上，不需要手動重新整理或重新計算"
  ],
  "nextSteps": "確認清單全數就緒後，可視需要將競賽狀態由草稿轉為發布，正式對外開放。",
  "faq": [
    {
      "q": "「類別」項目要怎麼樣才算就緒？",
      "a": "只要這場競賽存在至少一筆組別紀錄即顯示為就緒，即使該組別已被封存也算數（此項目目前只檢查「有沒有建立過」，不檢查是否仍為啟用狀態）；請見「如何設定競賽組別」。"
    },
    {
      "q": "「動態表單」跟「評分規準」分別對應什麼？",
      "a": "「動態表單」對應是否已有表單發布過至少一個版本（見「如何建立與發布表單」）；「評分規準」對應是否已建立至少一份 Rubric（見「如何建立評分規準」）。"
    },
    {
      "q": "這份清單會不會有項目永遠卡在「尚未開始」？",
      "a": "不會無故卡住，每一項都是依當下實際資料即時計算；若某項目持續顯示「尚未開始」，代表對應設定（例如排程的報名/投稿開始時間、評審設定的評審人數）確實尚未完成，請依清單旁的連結前往對應分頁補齊。"
    },
    {
      "q": "公告與提醒信信末的「主辦單位聯絡信箱」是從哪裡來的？",
      "a": "來自競賽總覽頁「設定」卡片的「聯絡信箱」欄位；沒有填寫時，公告 Email、補填提醒與報名提醒信都不會出現這一行。開賽前請確認它填的是要給參賽者聯絡的信箱。"
    }
  ]
}
